function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
var SvgMailIcon = function SvgMailIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 28 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.23007 1.71835C0.667969 3.28044 0.667969 5.7946 0.667969 10.8229C0.667969 15.8512 0.667969 18.3654 2.23007 19.9275C3.79216 21.4896 6.30632 21.4896 11.3346 21.4896H16.668C21.6963 21.4896 24.2104 21.4896 25.7725 19.9275C27.3346 18.3654 27.3346 15.8512 27.3346 10.8229C27.3346 5.7946 27.3346 3.28044 25.7725 1.71835C24.2104 0.15625 21.6963 0.15625 16.668 0.15625H11.3346C6.30632 0.15625 3.79216 0.15625 2.23007 1.71835ZM22.7695 4.8494C23.1231 5.27368 23.0658 5.90424 22.6415 6.2578L19.7128 8.69834C18.531 9.68322 17.5732 10.4815 16.7277 11.0252C15.8471 11.5916 14.9894 11.9494 14.0013 11.9494C13.0132 11.9494 12.1555 11.5916 11.2749 11.0252C10.4295 10.4815 9.47158 9.68322 8.28978 8.69835L5.36112 6.2578C4.93684 5.90424 4.87952 5.27368 5.23308 4.8494C5.58664 4.42512 6.21721 4.3678 6.64149 4.72136L9.52001 7.12013C10.764 8.15676 11.6276 8.87414 12.3567 9.34309C13.0626 9.79704 13.5412 9.94942 14.0013 9.94942C14.4614 9.94942 14.94 9.79704 15.6459 9.34309C16.375 8.87414 17.2386 8.15676 18.4826 7.12013L21.3611 4.72136C21.7854 4.3678 22.416 4.42512 22.7695 4.8494Z",
    fill: "black"
  }));
};
export default SvgMailIcon;